import { render, staticRenderFns } from "./CommentDetails.vue?vue&type=template&id=6d280c0c&scoped=true&"
import script from "./CommentDetails.vue?vue&type=script&lang=js&"
export * from "./CommentDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommentDetails.vue?vue&type=style&index=0&id=6d280c0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d280c0c",
  null
  
)

export default component.exports